export default __webpack_public_path__ + "static/media/866.6b5a3c9d.png";